module.exports = __webpack_public_path__ + "static/media/menu_reports.8c2c4d95.svg";